module.exports = __webpack_public_path__ + "img/J9.a8509600.png";